export default {
  portal: {
    iddleTime: 15,
    countdowntimer: 30,
  },
};
